import { render, staticRenderFns } from "./rate-promotions.vue?vue&type=template&id=2453f5b0&scoped=true&"
import script from "./rate-promotions.vue?vue&type=script&lang=js&"
export * from "./rate-promotions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2453f5b0",
  null
  
)

export default component.exports